export enum SelectorType {
    tagDefinition,
    identifier,
    constant,
    query,
    historianTag
}